/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import logo from 'assets/img/logo.svg';
import ToolsNavbar from "components/Navbars/ToolsNavbar.js";
import {TOOLS_INDEX} from "tools/ToolsIndex.js";
import SignInWithGoogle from "components/SignInWithGoogle.js"
// components

import IndexDropdown from "components/Dropdowns/IndexDropdown.js";

export default function Navbar({position}) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <nav className={"z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-white "}>
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <Link
              to="/"
              className="text-blueGray-700 text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
            >
              <img src={logo} className='navbarLogo'/>
            </Link>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block" : " hidden")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
               {
                  Object.entries(TOOLS_INDEX).map(([key, value])=>{
                    if(!value.enabled) return null;
                     return  (<li  id = {value.name+"-id"} className="flex items-center dropdown-tools">
                <a id = {value.name+"-a-id"}
                  className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href={value.route}
                  target="_self"
                >
                  <span id = {value.name+"span--id"} className="lg:hidden inline-block ml-2">{value.name}</span>
                </a>
              </li>)

                  })

               }



              <li className="flex items-center">
                <a
                  className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevtoolsonline.net"
                  target="_blank"
                >
                  <i className="text-blueGray-400 fab fa-facebook text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Share on facebook</span>
                </a>
              </li>

              <li className="flex items-center">
                <a
                  className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://twitter.com/intent/tweet?text=I%20loved%20using%20devtoolsonline.net%20for%20access%20to%20awesome%20dev%20tools%20for%20free!%20https%3A%2F%2Fdevtoolsonline.net"
                  target="_blank"
                >
                  <i className="text-blueGray-400 fab fa-twitter text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Tweet about us!</span>
                </a>
              </li>
               <li className="flex items-center">
                     <SignInWithGoogle/>
               </li>

              {/* <li className="flex items-center">
                <a
                  className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://github.com/creativetimofficial/notus-react?ref=nr-index-navbar"
                  target="_blank"
                >
                  <i className="text-blueGray-400 fab fa-github text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Star</span>
                </a>
              </li>

              <li className="flex items-center">
                <button
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
                  type="button"
                >
                  <i className="fas fa-arrow-alt-circle-down"></i> Sign Up
                </button>
              </li> */}
            </ul>
          </div>

        </div>
        <ToolsNavbar id = "navbar-tools"/>
      </nav>
    </>
  );
}
